<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            .settings__field-body
                settings-tab.settings__button(
                    :selected="params && params.fractions",
                    @click.native.prevent="fractionsHandler"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
        .settings__field(v-if='params.fractions')
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
            .settings__field-body
                cs-select.settings__select(
                    :options="possibleOptionsForFractions"
                    v-model="params.fractionalPart"
                )
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples') }}:
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.infinityAmountOfExamples",
                    :checked="params && params.infinityAmountOfExamples",
                )
</template>

<script>
    export default {
        props: {
            currentUserParams: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
        data() {
            return {
                params: null,
            };
        },
        watch: {
            currentUserParams: {
                handler(value) {
                    this.params = value;
                },
            },
            'params.operations.rootExtraction': {
                handler(val) {
                    // If rootExtraction is selected than force selecting 2 digits after dot
                    // because there are no numbers with 1 digit after dot to extract root from
                    if (val) {
                        this.params.fractionalPart = 2;
                    }
                },
            },
        },
        methods: {
            fractionsHandler() {
                this.params.fractions = !this.params.fractions;
            },
        },
        computed: {
            possibleOptionsForFractions() {
                if (this.params.operations.rootExtraction) {
                    return [2];
                }
                return 2;
            },
        },
    };
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 40px 15px;
        @include media($xl) {
            padding: 25px 40px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: center;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__button_space-right {
        margin-right: 32px;
    }
    .settings__columns {
        display: flex;
        width: 100%;
    }
    .settings__column {
        width: 100%;
        &:first-child {
            margin-right: 50px;
        }
    }
    .settings__fractions {
        display: flex;
        margin-top: 10px;
        min-height: 43px;
    }
    .select-container {
        display: flex;
        align-items: center;
    }
    .select-container__select {
        width: 70px;
    }
    .select-container__label {
        margin: 0 0 6px 20px;
        white-space: nowrap;
    }
    .settings__select {
        width: 60px;
    }
</style>
